import { render, staticRenderFns } from "./AreaMgrImpl.vue?vue&type=template&id=89ee39d2&scoped=true&"
import script from "./AreaMgrImpl.vue?vue&type=script&lang=js&"
export * from "./AreaMgrImpl.vue?vue&type=script&lang=js&"
import style0 from "./AreaMgrImpl.vue?vue&type=style&index=0&id=89ee39d2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ee39d2",
  null
  
)

export default component.exports